import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=4261d500&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=4261d500&prod&lang=scss&scoped=true&"
import style1 from "./MessageList.vue?vue&type=style&index=1&id=4261d500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261d500",
  null
  
)

export default component.exports